import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';

@Component({
  selector: 'simple-contact-details',
  template: `<form class="add-referral-form" [formGroup]="form" #formControl="ngForm" fxLayout="column" fxFlex>
            <div class="card">
                <div class="card-header"><span class="header-label">{{title}}</span></div>
                <div class="card-main">
                    <mat-form-field color="accent" class="w-100-p">
                    <mat-label>Name</mat-label>
                        <input id="{{prefix}}Name" matInput class="form-control" formControlName="{{prefix}}Name" name="{{prefix}}Name" required>
                    </mat-form-field>
                    <validation-errors [control]="controls.name"></validation-errors>

                    <mat-form-field color="accent" class="w-50-p short-input">
                      <mat-label>Telephone</mat-label>
                        <input id="{{prefix}}Telephone" matInput class="form-control" formControlName="{{prefix}}Telephone" name="{{prefix}}Telephone">
                    </mat-form-field>
                    <validation-errors [control]="controls.telephone"></validation-errors>

                    <mat-form-field color="accent" class="w-100-p">
                        <mat-label>Email</mat-label>
                        <input id="{{prefix}}Email" matInput class="form-control" formControlName="{{prefix}}Email" name="{{prefix}}Email" required>
                    </mat-form-field>
                    <validation-errors [control]="controls.email"></validation-errors>
                </div>
            </div>
          </form>`,
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class SimpleContactDetailsComponent implements OnInit {

  @Input() form: UntypedFormGroup;
  @Input() prefix: string;
  @Input() title: string;

  controls: any;

  constructor() { }

  ngOnInit(){
    this.controls = {
      name: this.form.get(`${this.prefix}Name`),
      telephone: this.form.get(`${this.prefix}Telephone`),
      email: this.form.get(`${this.prefix}Email`),
    };
  }
}
